/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.8.0-nightly.2026.10.13",
    versionName: "0.8.0-nightly.2026.10.13",
    versionChannel: "nightly",
    buildDate: "2026-10-13T00:17:51.220Z",
    commitHash: "46fec3f1b2e625fae7035bb3b00d6d5c0ec0d413",
};
